import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getTags } from "../api/tags";

export const tagsStore = SwApiStore({
  get: getTags,
  init: () => [],
});
